module.exports = __webpack_public_path__ + "img/CA2.7b83b6f9.jpg";